import {isClient} from './utils'

const gtm = {

  initialize(containerId, cookies) {
    if (!isClient()) {
      return
    }

    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','GoogleTagManager',containerId);

    if (cookies) {
      const gtmVariables = {
        utm_campaign: cookies.get('utm_campaign'),
        utm_medium: cookies.get('utm_medium'),
        utm_source: cookies.get('utm_source'),
        utm_referrer: cookies.get('utm_referrer'),
        utm_content: cookies.get('utm_content')
      }
      console.log('GTM: ', gtmVariables)
      window.GoogleTagManager.push(gtmVariables)
    }
  },

  event(eventName, values) {
    if (!isClient()) {
      return
    }

    const dataObj = {event: eventName}

    if (typeof values === 'object') {
      Object.assign(dataObj, values)
    }

    window.GoogleTagManager.push(dataObj)
    console.log('GTM event', dataObj)
  }

}

export default gtm
